import {Navbar} from "./Navbar";
import React from "react";
import {Box, Button, Card, CardContent, Container, Stack, Typography} from "@mui/joy";
import {CheckCircle, CheckCircleOutlined} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";


export function Confirmation() {
    const { i18n, t } = useTranslation();

    return (
        <Box sx={{height: '100vh'}}>
            <Navbar />
            <Container sx={{pt: "10rem"}}>
                <Stack spacing={3} direction="row" justifyContent="center" sx={{width:"100%"}}>
                    <Card variant="outlined" color="success" sx={{width: '500px', p:4}}>
                        <CardContent>
                            <Stack spacing={1} justifyContent="center" alignItems="center" textAlign="center">
                                <Typography level="h2" color="success"><CheckCircleOutlined /></Typography>
                                <Typography level="h2">{t("paymentcompleted")}</Typography>
                                <Typography sx={{pb:4}}>{t("paymentcompletedlabel")}</Typography>
                                <Link to="/">
                                    <Button color="success">
                                        {t("backtoaccount")}
                                    </Button>
                                </Link>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Container>
        </Box>
    )
}